// roomBookingReducer.ts
import { roomBookingActionTypes, roomBookingState, BalancePaymentDetails, PaymentDetail } from "./roomBookingTypes";

export const INIT_STATE: roomBookingState = {
    roomOptions: [],
    selectedRoomNumber: "",
    activeBookingId: null,
    guestName: "",
    balancePaymentDetails: {
        totalAccrued: 0,
        totalPaid: 0,
        balance: 0,
        details: []
    },
    isRoomListLoading: false,
    isBookingDetailsLoading: false,
    errorMessage: "",
    infoMessage: "Please select a room number to view booking details.",

};

const roomBookingReducer = (state = INIT_STATE, action: any): roomBookingState => {
    switch (action.type) {
        case roomBookingActionTypes.API_RESPONSE_SUCCESS:
            if (!action.payload?.actionType) {
                console.error(
                    `API_RESPONSE_SUCCESS: Missing actionType in payload. Action type: ${action.type}, Payload:`, action.payload
                );
                throw new Error(
                    `Reducer error: Missing actionType in payload for API_RESPONSE_SUCCESS. Action: ${JSON.stringify(action)}`
                );
            }

            switch (action.payload.actionType) {
                case roomBookingActionTypes.FETCH_ROOM_OPTIONS:
                    return {
                        ...state,
                        roomOptions: action.payload.data.roomOptions,
                        isRoomListLoading: false,
                        errorMessage: "",
                    };
                case roomBookingActionTypes.FETCH_BOOKING_DETAILS:
                    console.log("[roomBOOKINGReducer.ts] api success case FETCH_BOOKING_DETAILS",action.payload);
                    
                    return {
                        ...state,
                        activeBookingId: action.payload.data.activeBookingData.booking_id,
                        balancePaymentDetails: action.payload.data.balancePaymentDetails,
                        // balancePaymentDetails: action.payload.data,
                        guestName: action.payload.data.guestName,
                        isBookingDetailsLoading: false,
                        errorMessage: "",
                    };

                // case roomBookingActionTypes.APPROVED_ENTRY_SUBMIT:
                //     return {
                //         ...state,
                //         missingFields: action.payload.missingFields
                //         // roomOptions: action.payload.data.roomOptions,
                //         // isRoomListLoading: false,
                //         // errorMessage: "",
                //     };


                // Cases to be inserted later
                default:
                    return {
                        ...state,
                        isRoomListLoading: false,
                        isBookingDetailsLoading: false,
                    };
            }

        case roomBookingActionTypes.API_RESPONSE_ERROR:
            if (!action.payload?.actionType) {
                console.error(
                    `API_RESPONSE_ERROR: Missing actionType in payload. Action type: ${action.type}, Payload:`, action.payload
                );
                throw new Error(
                    `Reducer error: Missing actionType in payload for API_RESPONSE_ERROR. Action: ${JSON.stringify(action)}`
                );
            }

            switch (action.payload.actionType) {
                case roomBookingActionTypes.FETCH_ROOM_OPTIONS:
                    return {
                        ...state,
                        isRoomListLoading: false,
                        errorMessage: action.payload.error,
                        roomOptions: [],
                    };
                case roomBookingActionTypes.FETCH_BOOKING_DETAILS:
                    return {
                        ...state,
                        isBookingDetailsLoading: false,
                        errorMessage: action.payload.error,
                        activeBookingId: null,
                        balancePaymentDetails: {
                            totalAccrued: 0,
                            totalPaid: 0,
                            balance: 0,
                            details: [],
                        },
                    };

                // case roomBookingActionTypes.APPROVED_ENTRY_SUBMIT:
                //     console.log("[roomBookingActionTypes.APPROVED_ENTRY_SUBMIT:] error case",action.payload);
                    
                //     return {
                //         ...state,
                //         missingFields: action.payload.missingFields
                //         // isRoomListLoading: false,
                //         // errorMessage: action.payload.error,
                //         // roomOptions: [],
                //     };
                // Cases to be inserted later
                default:
                    return {
                        ...state,
                        isRoomListLoading: false,
                        isBookingDetailsLoading: false,
                        errorMessage: action.payload?.error || "An unknown error occurred",
                    };
            }
        case roomBookingActionTypes.FETCH_ROOM_OPTIONS:
            return {
                ...state,
                isRoomListLoading: true,
                errorMessage: "",
            };
        case roomBookingActionTypes.FETCH_BOOKING_DETAILS:
            return {
                ...state,
                isBookingDetailsLoading: true,
                errorMessage: "",
            };
        case roomBookingActionTypes.SET_SELECTED_ROOM_NUMBER:
            return {
                ...state,
                selectedRoomNumber: action.payload,
                infoMessage: "",
            };
        case roomBookingActionTypes.SET_ERROR_MESSAGE:
            return {
                ...state,
                errorMessage: action.payload,
            };
        case roomBookingActionTypes.CLEAR_ERROR_MESSAGE:
            return {
                ...state,
                errorMessage: "",
            };


        // case roomBookingActionTypes.APPROVED_ENTRY_SUBMIT:
        //     console.log("[roomBookingReducer.ts] APPROVED_ENTRY_SUBMIT pre api called with data", action.paylaod);
        //     return {
        //         ...state,
        //         // isBookingDetailsLoading: true,
        //         errorMessage: "",
        //     };

        default:
            return { ...state };
    }
};

export default roomBookingReducer;
